(function () {
  if (customElements.get('collection-pagination-exa')) return;

  customElements.define('collection-pagination-exa', class CollectionPaginationExa extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.button = this.querySelector('[data-load-more]');
      this.status = this.querySelector('[data-load-status]');
      this.nextUrl = this.getAttribute('data-next-url') || '';
      this.mode = this.getAttribute('data-mode') || 'load_more';
      this.loading = false;
      this._onClick = () => this.loadNextPage();
      if (this.button) this.button.addEventListener('click', this._onClick);
      if (this.mode === 'infinite' && 'IntersectionObserver' in window) {
        if (this.button) this.button.hidden = true;
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
        }, { rootMargin: '500px 0px' });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.button && this._onClick) this.button.removeEventListener('click', this._onClick);
      if (this.observer) this.observer.disconnect();
      if (this.controller) this.controller.abort();
      this._connected = false;
    }

    async loadNextPage() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;
      this.controller = new AbortController();
      if (this.button) {
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.button.textContent = this.getAttribute('data-loading-label') || 'Loading…';
      }
      if (this.status) this.status.textContent = this.getAttribute('data-loading-label') || 'Loading…';

      try {
        const response = await fetch(this.nextUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          signal: this.controller.signal
        });
        if (!response.ok) throw new Error('Unable to load the next collection page.');
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = documentFragment.querySelector('#ProductGridContainer #product-grid');
        const currentContainer = this.closest('#ProductGridContainer');
        const currentGrid = currentContainer ? currentContainer.querySelector('#product-grid') : null;
        if (!nextGrid || !currentGrid) throw new Error('The next product grid was not found.');

        const nextItems = Array.from(nextGrid.children);
        nextItems.forEach((item) => {
          item.classList.remove('animate--hidden');
          item.classList.add('animate--shown');
          currentGrid.appendChild(item);
        });

        const nextController = documentFragment.querySelector('#ProductGridContainer collection-pagination-exa');
        this.nextUrl = nextController ? nextController.getAttribute('data-next-url') || '' : '';
        this.setAttribute('data-next-url', this.nextUrl);
        if (this.status) {
          const message = this.getAttribute('data-loaded-label') || '[count] more products loaded';
          this.status.textContent = message.replace('[count]', String(nextItems.length));
        }
        this.dispatchEvent(new CustomEvent('collection-pagination-exa:loaded', {
          bubbles: true,
          detail: { count: nextItems.length, nextUrl: this.nextUrl }
        }));

        if (!this.nextUrl) {
          if (this.observer) this.observer.disconnect();
          this.remove();
          return;
        }
        if (this.button) {
          this.button.hidden = this.mode === 'infinite' && Boolean(this.observer);
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          this.button.textContent = this.getAttribute('data-button-label') || 'Load more';
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (this.button) {
          this.button.hidden = false;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          this.button.textContent = this.getAttribute('data-button-label') || 'Load more';
        }
        if (this.status) this.status.textContent = this.getAttribute('data-error-label') || 'Products could not be loaded. Please try again.';
      } finally {
        this.loading = false;
        this.controller = null;
      }
    }
  });
})();
